RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.EmailVerificationModal = Marionette.ItemView.extend({

        template: '#accountVerificationRequiredModal',
        className: 'modal',
        attributes: {
            tabindex: -1
        },

        ui: {
            resendEmailBtn: '.x-resend-email-btn'
        },

        events: {
            'click @ui.resendEmailBtn': 'onResendButton'
        },

        onBeforeRender: function () {
            RivalIQ.execute('tracking:push', RivalIQ.tracking.metric.ViewedPurchaseBeforeEmailVerified);
        },

        templateHelpers: function () {

            return {
                email: RivalIQ.state.user.get('email')
            };
        },

        onResendButton: function () {
            const me = this;

            me.ui.resendEmailBtn.toggleClass('disabled', true);
            $.ajax({
                type: 'POST',
                url: '/api/users/resendVerificationEmail',
                data: {
                    email: RivalIQ.state.user.get('email'),
                    _csrf: RivalIQ.state.product.get('csrfToken')
                },
                error: function () {
                    me.ui.resendEmailBtn.toggleClass('disabled', false);
                },
                success: function () {
                    RivalIQ.execute('alert:info', 'Email sent!');
                    RivalIQ.execute('hide:modal');
                }
            });
        }
    });
});
